import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function ItemLegendAxisValues(t0) {
  const $ = _c(3);
  const {
    width
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="h-3 w-3 rounded-full md:h-4 md:w-4" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== width) {
    t2 = <div className="flex flex-row items-center gap-1">{t1}<Skeleton className="h-[10.5px] rounded-md md:h-3.5" style={{
        width
      }} /></div>;
    $[1] = width;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export { ItemLegendAxisValues };